// Module
var code = "<div class=\"paymentFailedModal t-paymentFailedModal\"> <div class=\"paymentFailedModal_wrapper\"> <cHeader aria-describe-id=\"paymentFailed\" :headline=\"getPaymentFailureText.headline\" icon=\"cancel\" :sub-headline=\"getPaymentFailureText.subHeadline\"/> <cButton design=\"secondary\"> <slot/> </cButton> </div> </div> ";
// Exports
export default code;